import {
  TModelValueType,
} from './input-qmulus-dashboard-widget-limit.ts';

const modelValueType: Record<TModelValueType, string> = {
  auto: 'Automatický',
  value: 'Statický',
  factoredLimit: 'Dynamický',
};

export default {
  modelValueType,
};
